<template>
    <div class="block-content block-content-full">
        <div class="block rounded-24 w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Informations générales</h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-9">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="title" class="form-label">Nom<span class="text-purple">*</span></label>
                                        <input v-model="menu.title" id="title" class="form-control" placeholder="Nom" required />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="subtitle" class="form-label">Sous-titre </label>
                                        <input
                                            v-model="menu.subtitle"
                                            id="subtitle"
                                            class="form-control"
                                            placeholder="Sous-titre"
                                        />
                                    </div>
                                </div>

                                <div class="col-4">
                                    <label class="form-label" for="vat_rate">Taux de TVA<span class="text-purple">*</span></label>
                                    <div class="input-group rounded-24 overflow-hidden">
                                        <span class="input-group-text btn-yellow border-0">%</span>
                                        <select
                                            v-model="menu.vat_rate"
                                            class="form-select form-control"
                                            @change="calculatePriceHT()"
                                            required
                                        >
                                            <option v-for="vat in country_vat_rates" :key="vat.id" :value="vat.pourcentage">
                                                {{ vat.pourcentage }} - {{ vat.name }}
                                            </option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-4">
                                    <label class="form-label" for="price">Prix de vente<span class="text-purple">*</span></label>
                                    <div class="input-group rounded-24 overflow-hidden">
                                        <span class="input-group-text btn-primary ppv2-text-black border-0">{{
                                            $symbolCurrency
                                        }}</span>
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="menu.price"
                                            placeholder="Prix"
                                            required
                                            @input="calculatePrice()"
                                        />
                                    </div>
                                </div>

                                <div class="col-4">
                                    <label class="form-label" for="price_ht">Prix HT<span class="text-purple">*</span></label>
                                    <div class="input-group rounded-24 overflow-hidden">
                                        <span class="input-group-text btn-primary ppv2-text-black border-0">{{
                                            $symbolCurrency
                                        }}</span>
                                        <input
                                            type="number"
                                            step="any"
                                            class="form-control"
                                            v-model="menu.price_ht"
                                            placeholder="Prix HT"
                                            required
                                            @input="calculatePriceHT()"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="parentCategory" class="form-label"
                                            >Catégorie<span class="text-purple">*</span></label
                                        >
                                        <v-select
                                            class="custom-select"
                                            id="parentCategory"
                                            v-model="menu.category_id"
                                            :options="ListCategories"
                                            label="title"
                                            :placeholder="'-- Sélectionnez une catégorie --'"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="kitchen" class="form-label">Cuisine<span class="text-purple">*</span></label>
                                        <v-select
                                            class="custom-select"
                                            id="kitchen"
                                            v-model="menu.kitchen_id"
                                            :options="ListKitchens"
                                            label="title"
                                            :placeholder="'-- Sélectionnez une cuisine --'"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="shortDescription" class="form-label">Short Description:</label>
                                        <textarea
                                            v-model="menu.short_description"
                                            id="shortDescription"
                                            class="form-control"
                                            placeholder="Short Description"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-12 col-xs-12">
                                    <div class="form-group">
                                        <label for="description" class="form-label">Description:</label>
                                        <textarea
                                            v-model="menu.description"
                                            id="description"
                                            class="form-control"
                                            placeholder="Description"
                                        ></textarea>
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="seoTitle" class="form-label">SEO Title:</label>
                                        <input
                                            v-model="menu.seo_title"
                                            id="seoTitle"
                                            class="form-control"
                                            placeholder="SEO Title"
                                        />
                                    </div>
                                </div>

                                <div class="col-lg-6 col-xs-12">
                                    <div class="form-group">
                                        <label for="seoKeywords" class="form-label">SEO Keywords:</label>
                                        <input
                                            v-model="menu.seo_keywords"
                                            id="seoKeywords"
                                            class="form-control"
                                            placeholder="SEO Keywords"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-12 col-xs-12">
                                <div class="form-group">
                                    <label for="seoDescription" class="form-label">SEO Description:</label>
                                    <textarea
                                        v-model="menu.seo_description"
                                        id="seoDescription"
                                        class="form-control"
                                        placeholder="SEO Description"
                                    ></textarea>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mb-4 mt-5" style="gap: 20px">
                                <a
                                    href="/back-office/food/menu"
                                    class="btn fs-sm btn-outline-dark py-2 mx-2 rounded-12 fw-medium width-btn"
                                >
                                    Annuler
                                </a>
                                <button type="submit" class="btn fs-sm btn-dark py-2 rounded-12 fw-medium width-btn">
                                    {{ Object.keys(this.data).length === 0 ? 'Ajouter' : 'Mettre à jour' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
    props: ['data', 'country_vat_rates'],
    data() {
        return {
            menu: {
                title: '',
                subtitle: '',
                description: '',
                seo_description: '',
                seo_title: '',
                seo_keywords: '',
                short_description: '',
                image: '',
                price: '',
                price_ht: '',
                vat_rate: 0,
                category_id: '-- Selectionne la catégorie --',
                kitchen_id: '-- Selectionne la cuisine --',
            },
            categories: [],
            kitchens: [],
        }
    },

    computed: {
        ListCategories() {
            return this.categories
        },
        ListKitchens() {
            return this.kitchens
        },
    },

    methods: {
        calculatePrice() {
            if (this.menu.vat_rate !== '') {
                this.menu.price_ht = (parseFloat(this.menu.price) / (1 + parseFloat(this.menu.vat_rate) / 100)).toFixed(2)
            }
        },

        calculatePriceHT() {
            if (this.menu.vat_rate !== '') {
                this.menu.price = (parseFloat(this.menu.price_ht) * (1 + parseFloat(this.menu.vat_rate) / 100)).toFixed(2)
            }
        },

        handleSubmit() {
            if (Object.keys(this.data).length !== 0) {
                this.updateMenu()
            } else {
                this.storeMenu()
            }
        },

        storeMenu() {
            if (this.menu.category_id === '-- Selectionne la catégorie --') {
                this.menu.category_id = null
            }

            if (this.menu.kitchen_id === '-- Selectionne la cuisine --') {
                this.menu.kitchen_id = null
            }

            axios
                .post('/back-office/food/menu', this.menu)
                .then((response) => {
                    console.log('Category created:', response.data)
                    window.location.href = '/back-office/food/menu/'
                })
                .catch((error) => {
                    console.error('Error creating menu:', error)
                    this.showErrors(error)
                })
        },

        updateMenu() {
            const menuId = this.data.id
            axios
                .put(`/back-office/food/menu/${menuId}`, this.menu)
                .then((response) => {
                    console.log('updated:', response.data)
                    this.$toast.success('response.data.message')
                })
                .catch((error) => {
                    console.error('Error updating menu:', error)
                    this.showErrors(error)
                })
        },

        fetchCategories() {
            axios
                .get('/back-office/food/category/list/fast')
                .then((response) => {
                    this.categories = response.data?.data
                })
                .catch((error) => {
                    console.error('Error fetching categories:', error)
                })
        },

        fetchKitchens() {
            axios
                .get('/back-office/food/kitchen/list/fast')
                .then((response) => {
                    console.log('resp', response.data)
                    this.kitchens = response.data?.data
                })
                .catch((error) => {
                    console.error('Error fetching categories:', error)
                })
        },

        showErrors(response) {
            console.log('response', response)
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors

                console.log('errors', errors)

                for (const key in errors) {
                    const errorMessage = errors[key][0]

                    console.log('errorMessage', errorMessage)

                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },
    },

    mounted() {
        if (Object.keys(this.data).length !== 0) {
            this.menu = { ...this.data }
            console.log('menu.category_id', this.menu)
            this.menu.category_id = {
                id: this.data?.category?.id,
                title: this.data?.category?.title,
            }

            this.menu.kitchen_id = {
                id: this.data?.kitchen?.id,
                title: this.data?.kitchen?.title,
            }
        }
        this.fetchCategories()
        this.fetchKitchens()
    },

    components: {
        vSelect,
    },
}
</script>

<style lang="scss">
#parentCategory .vs__dropdown-toggle,
#kitchen .vs__dropdown-toggle {
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    height: 50px;
}
</style>
